import styled from 'styled-components/macro';

export const StyledWalletWrapper = styled.div`
    display: flex;
    width: 100%;
    margin: 2.4rem 0 3.2rem;
`;
